if(!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.size = +this.dataset.size;
      this.mobileSize = 2;
      this.desktopSize = 5;
    }

    destroySlider() {
      if(!this.slider) return;

      this.slider.destroy();
    }

    initSlider() {
      if(this.slider) return;

      this.slider = new Flickity(this, {
        pageDots: false,
        wrapAround: true,
        arrowShape: 'M 10 50 L 50 90 L 55 85 L 20 50 L 55 15 L 50 10 Z',
        cellAlign: 'left'
      });
    }

    connectedCallback() {
      if(!Flickity) return;
      if(window.innerWidth > 767 && this.size > this.desktopSize) this.initSlider();
      if(window.innerWidth < 767 && this.size > this.mobileSize) this.initSlider();
    }
  }

  customElements.define('product-slider', ProductSlider);
}
